import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AuthService } from '../../services/auth/auth.service';
import { CameraService } from '../../services/camera/camera.service';
import { ConfigService } from '../../services/config/config.service';
import { DateService } from '../../services/date/date.service';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { VideoRequestsService } from '../../services/video-requests/video-requests.service';
import { Business } from '../../services/trucks/truck.model';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
var CreateVideoRequestComponent = /** @class */ (function () {
    function CreateVideoRequestComponent(route, authService, cameraService, configService, dateService, flashMessagesService, router, returnUrlService, videoRequestService) {
        var _this = this;
        this.route = route;
        this.authService = authService;
        this.cameraService = cameraService;
        this.configService = configService;
        this.dateService = dateService;
        this.flashMessagesService = flashMessagesService;
        this.router = router;
        this.returnUrlService = returnUrlService;
        this.videoRequestService = videoRequestService;
        this.messageIds = {
            httpError: null
        };
        this.hours = [];
        this.minutes = [];
        this.meridiems = [];
        this.userInfo = this.authService.userInfo;
        // TODO: Add guards for invalid params here.
        var snapshot = this.route.snapshot;
        this.truckNumber = snapshot.paramMap.get('truckNumber');
        this.computerType = snapshot.queryParamMap.get('computerType');
        this.deviceId = snapshot.queryParamMap.get('deviceId');
        this.ipAddress = snapshot.queryParamMap.get('ipAddress');
        this.location = snapshot.queryParamMap.get('location');
        this.site = snapshot.queryParamMap.get('site');
        this.softwareVersion = parseFloat(snapshot.queryParamMap.get('softwareVersion'));
        this.timestamp = moment.parseZone(snapshot.queryParamMap.get('timestamp'));
        this.business = Business[snapshot.queryParamMap.get('business')];
        this.cameras = this.cameraService.getCameras(this.computerType); // TODO: Error
        this.selectedCamerasMap = new Map();
        this.cameras.forEach(function (camera) {
            _this.selectedCamerasMap.set(camera, false);
        });
        for (var i = 1; i <= 12; i++) {
            this.hours.push(i.toString().padStart(2, '0'));
        }
        for (var i = 0; i <= 59; i++) {
            this.minutes.push(i.toString().padStart(2, '0'));
        }
        this.meridiems.push("AM");
        this.meridiems.push("PM");
        var requestDate = this.timestamp.clone().startOf('day');
        this.oldest = moment.utc().utcOffset(this.timestamp.utcOffset(), false).startOf('day').subtract(this.configService.config.allowedDaysInThePast, 'days');
        var half = Math.floor(configService.config.defaultVideoRequestLengthMinutes / 2.0);
        // from is half the default length before the time, but minimum of the start of the day
        var fromTime = this.timestamp.clone().subtract(half, 'minutes');
        if (fromTime.isBefore(requestDate)) {
            fromTime = requestDate.clone();
        }
        var toTime = fromTime.clone().add(configService.config.defaultVideoRequestLengthMinutes, 'minutes');
        // Put the YMD/HMS values into Date objects, for binding to UI controls.
        this.requestFromTime = this.dateService.momentPartsToBindableDate(fromTime);
        this.requestToTime = this.dateService.momentPartsToBindableDate(toTime);
        this.requestDate = this.dateService.momentPartsToBindableDate(requestDate);
        this.returnUrlService.save();
    }
    Object.defineProperty(CreateVideoRequestComponent.prototype, "businessCaption", {
        get: function () {
            return Business[this.business];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "cost", {
        get: function () {
            if (this.isFreeDownload) {
                return 0;
            }
            var selectedCamerasCount = 0;
            this.selectedCamerasMap.forEach(function (value, key) {
                if (value) {
                    selectedCamerasCount = selectedCamerasCount + 1;
                }
            });
            return this.userInfo.costPerCameraMinute
                ? this.userInfo.costPerCameraMinute * selectedCamerasCount * this.numberOfCameraMinutes
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "minPickerDate", {
        get: function () {
            return this.dateService.momentPartsToBindableDate(this.oldest);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "maxPickerDate", {
        get: function () {
            var start = moment.utc().utcOffset(this.timestamp.utcOffset(), false).startOf('day');
            return this.dateService.momentPartsToBindableDate(start);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "offsetCaption", {
        get: function () {
            return this.timestamp.format("Z");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "formattedDate", {
        get: function () {
            return this._requestDate.toLocaleDateString('en-AU');
        },
        set: function (date) {
            this._requestDate = moment(date).toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "numberOfCameraMinutes", {
        get: function () {
            var to = moment(this.requestToTime);
            var from = moment(this.requestFromTime);
            var diffMs = to.diff(from);
            var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
            return diffMins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "organisation", {
        get: function () {
            return this.userInfo.councilName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "requestDate", {
        get: function () {
            return this._requestDate;
        },
        set: function (date) {
            this._requestDate = date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "requestFromTime", {
        get: function () {
            this._requestFromTime = this.combine(this.requestDate, new Date(this.requestDate.getFullYear(), this.requestDate.getMonth(), this.requestDate.getDay(), this.convert12HoursTo24Hours(parseInt(this.selectedFromHour, 10), this.selectedFromMeridiem), parseInt(this.selectedFromMinute, 10)));
            return this._requestFromTime;
        },
        set: function (date) {
            this._requestFromTime = date;
            this.selectedFromHour = this.convert24HoursTo12Hours(date.getHours()).toString().padStart(2, '0');
            this.selectedFromMinute = date.getMinutes().toString().padStart(2, '0');
            this.selectedFromMeridiem = this.getMeridiemFor24Hours(date.getHours());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "requestToTime", {
        get: function () {
            this._requestToTime = this.combine(this.requestDate, new Date(this.requestDate.getFullYear(), this.requestDate.getMonth(), this.requestDate.getDay(), this.convert12HoursTo24Hours(parseInt(this.selectedToHour, 10), this.selectedToMeridiem), parseInt(this.selectedToMinute, 10)));
            return this._requestToTime;
        },
        set: function (date) {
            this._requestToTime = date;
            this.selectedToHour = this.convert24HoursTo12Hours(date.getHours()).toString().padStart(2, '0');
            this.selectedToMinute = date.getMinutes().toString().padStart(2, '0');
            this.selectedToMeridiem = this.getMeridiemFor24Hours(date.getHours());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateVideoRequestComponent.prototype, "selectedCameras", {
        get: function () {
            var selectedCameras = [];
            this.selectedCamerasMap.forEach(function (value, key) {
                if (value) {
                    selectedCameras.push(key);
                }
            });
            return this.cameraService.transform(selectedCameras);
        },
        enumerable: true,
        configurable: true
    });
    CreateVideoRequestComponent.prototype.datePickerShouldBeDisabled = function () {
        var isUnitSearch = this.router.routerState.snapshot.root.queryParams['searchType'] === 'unit-search';
        var userIsInJJrRole = this.userInfo.isInRole('jjr');
        var enableDatePicker = userIsInJJrRole && isUnitSearch;
        return !enableDatePicker;
    };
    CreateVideoRequestComponent.prototype.hasAtLeastOneSelectedCamera = function () {
        var hasASelectedCamera = false;
        this.selectedCamerasMap.forEach(function (value) {
            if (value === true) {
                hasASelectedCamera = true;
            }
        });
        return hasASelectedCamera;
    };
    CreateVideoRequestComponent.prototype.hasValidRequestDate = function () {
        // The date of the request must be between today (in the Site time zone),
        // and the oldest configured request date (inclusive).
        var todaySiteLocal = moment.utc().utcOffset(this.timestamp.utcOffset(), false).startOf('day');
        var requestDateSiteLocal = moment(this.requestDate).utcOffset(this.timestamp.utcOffset(), true);
        return (requestDateSiteLocal.isSameOrAfter(this.oldest) && requestDateSiteLocal.isSameOrBefore(todaySiteLocal));
    };
    CreateVideoRequestComponent.prototype.getRequestLength = function () {
        var start = moment(this.combine(this.requestDate, this.requestFromTime));
        var end = moment(this.combine(this.requestDate, this.requestToTime));
        var duration = null;
        if (start <= end) {
            duration = moment.duration(end.diff(start));
        }
        else {
            // Note: This handles the case where e.g. from = 11:59PM and to = 12:01AM.
            duration = moment.duration(end.add(1, 'days').diff(start));
        }
        // The length of the video request must be at least 1 minute,
        // and less than (or equal to) the maximum configured video request length.
        return duration.asMinutes();
    };
    CreateVideoRequestComponent.prototype.hasValidRequestLength = function () {
        var minutes = this.getRequestLength();
        return minutes > 0 && minutes <= this.maxAllowedMinutes;
    };
    CreateVideoRequestComponent.prototype.hasValidRequestLengthOrZero = function () {
        var minutes = this.getRequestLength();
        return minutes <= this.maxAllowedMinutes;
    };
    CreateVideoRequestComponent.prototype.hasRequestLengthNonZero = function () {
        var minutes = this.getRequestLength();
        return minutes > 0;
    };
    CreateVideoRequestComponent.prototype.hasValidReasonLength = function () {
        return (this.reason && this.reason.length > 1000) ? false : true;
    };
    Object.defineProperty(CreateVideoRequestComponent.prototype, "maxAllowedMinutes", {
        get: function () {
            return (this.isFreeDownload || false)
                ? this.configService.config.allowedFreeDownloadVideoRequestLengthMinutes
                : this.configService.config.allowedVideoRequestLengthMinutes;
        },
        enumerable: true,
        configurable: true
    });
    CreateVideoRequestComponent.prototype.hasValidRequestTime = function () {
        // Now requestTimeEnd must be less than right now (i.e. no video requests in the future).
        // First we ned to build the "From" and "To" times by combining the request date with the appropriate time control.
        // Then, because truck requests are made in "Site Local Time" convert to UTC to ensure we can compare "now" with the
        // values to detect properly if they are in the past.
        var dateFromInput = this.combine(this.requestDate, this.requestFromTime);
        var dateToInput = this.combine(this.requestDate, this.requestToTime);
        var offset = this.timestamp.utcOffset();
        var dateFrom = this.dateService.bindableDatePartsToMoment(dateFromInput, offset);
        var dateTo = this.dateService.bindableDatePartsToMoment(dateToInput, offset);
        var nowUtc = moment().utc();
        return (dateFrom.isSameOrBefore(nowUtc) && dateTo.isSameOrBefore(nowUtc));
    };
    CreateVideoRequestComponent.prototype.isValid = function () {
        return !!(this.title &&
            this.requestFromTime &&
            this.requestToTime &&
            this.requestDate &&
            this.hasAtLeastOneSelectedCamera() &&
            this.hasValidRequestDate() &&
            this.hasValidRequestLength() &&
            this.hasValidRequestTime() &&
            this.hasValidReasonLength());
    };
    CreateVideoRequestComponent.prototype.onFreeDownloadChanged = function (value) {
        if (value) {
            if (this.userInfo.isFreeUser) {
                $(this.freeDownloadDisclaimerModal.nativeElement).modal('show');
            }
            else {
                this.isFreeDownload = false;
            }
        }
    };
    CreateVideoRequestComponent.prototype.onCameraSelected = function (camera, value) {
        this.selectedCamerasMap.set(camera, value);
    };
    CreateVideoRequestComponent.prototype.rejectFreeDownload = function () {
        this.isFreeDownload = false;
    };
    CreateVideoRequestComponent.prototype.requestVideo = function () {
        var _this = this;
        this.flashMessagesService.clear(this.messageIds.httpError);
        // requestDate, requestFromTime, requestToTime, are all JS Date objects for binding to the UI
        // they are all local values for the browser,
        // but with the input values interpreted as local for the site
        // e.g. input '15:12' in an Brisbane browser is a Date object for +10 (so is actually 05:12+0),
        // but we want it interpreted as local to the site, e.g. Auckland, as 15:12+13.
        var dateFromInput = this.combine(this.requestDate, this.requestFromTime);
        var dateToInput = this.combine(this.requestDate, this.requestToTime);
        var offset = this.timestamp.utcOffset();
        var dateFrom = this.dateService.bindableDatePartsToMoment(dateFromInput, offset);
        var dateTo = this.dateService.bindableDatePartsToMoment(dateToInput, offset);
        var videoRequest = {
            cameras: this.selectedCameras,
            computerType: this.computerType,
            deviceId: this.deviceId,
            dateFrom: dateFrom.format(),
            dateTo: dateTo.format(),
            ipAddress: this.ipAddress,
            location: this.location,
            reason: this.reason,
            site: this.site,
            softwareVersion: this.softwareVersion,
            title: this.title,
            truckNumber: this.truckNumber,
            isFreeDownload: this.isFreeDownload,
            business: this.business,
        };
        this.videoRequestService.put(videoRequest).subscribe(function (vrrId) {
            // noinspection JSIgnoredPromiseFromCall
            _this.router.navigate(['video-requests', vrrId]);
        }, function (error) {
            _this.messageIds.httpError = _this.flashMessagesService.addMessageFor(error);
        });
    };
    // noinspection JSMethodCanBeStatic
    CreateVideoRequestComponent.prototype.combine = function (date, time) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
    };
    CreateVideoRequestComponent.prototype.convert12HoursTo24Hours = function (hours, meridiem) {
        if (meridiem.toUpperCase() === "AM") {
            if (hours === 12) {
                return 0;
            }
            return hours;
        }
        if (meridiem.toUpperCase() === "PM") {
            if (hours === 12) {
                return hours;
            }
            return hours + 12;
        }
        return hours;
    };
    CreateVideoRequestComponent.prototype.convert24HoursTo12Hours = function (hours) {
        if (hours === 0) {
            return 12;
        }
        if (hours <= 12) {
            return hours;
        }
        return hours - 12;
    };
    CreateVideoRequestComponent.prototype.getMeridiemFor24Hours = function (hours) {
        if (hours <= 11) {
            return "AM";
        }
        return "PM";
    };
    return CreateVideoRequestComponent;
}());
export { CreateVideoRequestComponent };
